import customFetch from './customFetch';
import customResponse from './customResponse'

export default (httpClient) => function* crudSaga() {
  yield [
    customFetch(httpClient)(),
    customResponse(),
  ];
};



// WEBPACK FOOTER //
// ./src/sideEffect/saga/customSaga.js